export default "This view shows information on internal PBX calls.\n\nA recap chart provides aggregated data, then a table displays detailed CDR data\n";